<template>
  <div :class="['header', bgColorClass]">
    <div class="title-help-container">
      <div class="title">
        <h2 v-if="title">
          <span class="title-inner"
            ><span v-if="isArchived" title="Ärendet är arkiverat"
              ><svg
                class="is-archived"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 7H18V6C18 5.20435 17.6839 4.44129 17.1213 3.87868C16.5587 3.31607 15.7956 3 15 3H5C4.20435 3 3.44129 3.31607 2.87868 3.87868C2.31607 4.44129 2 5.20435 2 6V18C2 18.7956 2.31607 19.5587 2.87868 20.1213C3.44129 20.6839 4.20435 21 5 21H19C19.7956 21 20.5587 20.6839 21.1213 20.1213C21.6839 19.5587 22 18.7956 22 18V10C22 9.20435 21.6839 8.44129 21.1213 7.87868C20.5587 7.31607 19.7956 7 19 7ZM5 5H15C15.2652 5 15.5196 5.10536 15.7071 5.29289C15.8946 5.48043 16 5.73478 16 6V7H5C4.73478 7 4.48043 6.89464 4.29289 6.70711C4.10536 6.51957 4 6.26522 4 6C4 5.73478 4.10536 5.48043 4.29289 5.29289C4.48043 5.10536 4.73478 5 5 5ZM20 15H19C18.7348 15 18.4804 14.8946 18.2929 14.7071C18.1054 14.5196 18 14.2652 18 14C18 13.7348 18.1054 13.4804 18.2929 13.2929C18.4804 13.1054 18.7348 13 19 13H20V15ZM20 11H19C18.2044 11 17.4413 11.3161 16.8787 11.8787C16.3161 12.4413 16 13.2044 16 14C16 14.7956 16.3161 15.5587 16.8787 16.1213C17.4413 16.6839 18.2044 17 19 17H20V18C20 18.2652 19.8946 18.5196 19.7071 18.7071C19.5196 18.8946 19.2652 19 19 19H5C4.73478 19 4.48043 18.8946 4.29289 18.7071C4.10536 18.5196 4 18.2652 4 18V8.83C4.32127 8.94302 4.65943 9.00051 5 9H19C19.2652 9 19.5196 9.10536 19.7071 9.29289C19.8946 9.48043 20 9.73478 20 10V11Z"
                  fill="#fff"
                ></path></svg></span
            >{{ title }}</span
          >
          <span v-if="subtitle" class="subtitle" :class="[bgColorClass]">{{
            subtitle
          }}</span>
          <slot name="chain-link" />
        </h2>
        <h3 v-if="landlordName" class="landlord-name">
          <img :src="svgs.ICONS.CITY" />{{ landlordName }}
        </h3>
      </div>
      <button
        v-if="showHelpButton"
        type="button"
        class="link"
        :class="{ active: showTutorialOnClick }"
        @click="showTutorialOnClick"
      >
        <div class="icon">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.29 13.29C9.247 13.3375 9.20693 13.3876 9.17 13.44C9.13216 13.4957 9.10189 13.5563 9.08 13.62C9.05117 13.6767 9.03095 13.7374 9.02001 13.8C9.0151 13.8666 9.0151 13.9334 9.02001 14C9.01663 14.1312 9.04402 14.2613 9.10001 14.38C9.14492 14.5041 9.21657 14.6168 9.30989 14.7101C9.40321 14.8034 9.51591 14.8751 9.64001 14.92C9.75971 14.9729 9.88913 15.0002 10.02 15.0002C10.1509 15.0002 10.2803 14.9729 10.4 14.92C10.5241 14.8751 10.6368 14.8034 10.7301 14.7101C10.8234 14.6168 10.8951 14.5041 10.94 14.38C10.9844 14.2584 11.0048 14.1294 11 14C11.0008 13.8684 10.9755 13.7379 10.9258 13.6161C10.876 13.4943 10.8027 13.3834 10.71 13.29C10.617 13.1963 10.5064 13.1219 10.3846 13.0711C10.2627 13.0203 10.132 12.9942 10 12.9942C9.86799 12.9942 9.73729 13.0203 9.61543 13.0711C9.49357 13.1219 9.38297 13.1963 9.29 13.29ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C18 12.1217 17.1572 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18ZM10 5C9.47307 4.99966 8.95534 5.13812 8.49891 5.40144C8.04249 5.66476 7.66347 6.04366 7.4 6.5C7.32765 6.61382 7.27907 6.7411 7.25718 6.87418C7.23529 7.00726 7.24055 7.14339 7.27263 7.27439C7.30472 7.40538 7.36297 7.52854 7.44389 7.63643C7.52481 7.74433 7.62671 7.83475 7.74348 7.90224C7.86024 7.96974 7.98945 8.01292 8.12334 8.02918C8.25722 8.04544 8.39301 8.03445 8.52254 7.99688C8.65207 7.9593 8.77266 7.89591 8.87705 7.81052C8.98145 7.72513 9.06749 7.6195 9.13 7.5C9.21811 7.3474 9.34497 7.22078 9.49775 7.13298C9.65053 7.04518 9.82379 6.9993 10 7C10.2652 7 10.5196 7.10536 10.7071 7.29289C10.8946 7.48043 11 7.73478 11 8C11 8.26522 10.8946 8.51957 10.7071 8.70711C10.5196 8.89464 10.2652 9 10 9C9.73479 9 9.48043 9.10536 9.2929 9.29289C9.10536 9.48043 9 9.73478 9 10V11C9 11.2652 9.10536 11.5196 9.2929 11.7071C9.48043 11.8946 9.73479 12 10 12C10.2652 12 10.5196 11.8946 10.7071 11.7071C10.8946 11.5196 11 11.2652 11 11V10.82C11.6614 10.58 12.2174 10.1152 12.5708 9.50687C12.9242 8.89851 13.0525 8.18529 12.9334 7.49189C12.8143 6.79849 12.4552 6.16902 11.919 5.71352C11.3828 5.25801 10.7035 5.00546 10 5Z"
              fill="#fff"
            />
          </svg>
        </div>
        <span>Hjälp</span>
      </button>
    </div>
    <div ref="tabs" class="tabs">
      <div class="tabs-inner">
        <span
          ref="activeBg"
          class="no-pointer-events active-bg"
          :class="{
            'active-bg--no-transition': !useTransitionForActiveBg
          }"
        ></span>
        <button
          v-for="(tab, idx) in tabs"
          v-show="!tab.hidden"
          :key="idx"
          :disabled="allDisabled || tab.disabled ? true : false"
          :class="['tab', tab.active ? 'active' : '']"
          @click="tabClick(tab.tabLink, tab.active)"
        >
          <span style="position: relative">
            <span
              style="display: inline-flex; align-items: center; gap: 7px"
              v-html="tab.title"
            ></span>
            <NotificationSymbol
              v-if="tab.showNotification"
              :offset-right="-12"
              :offset-top="-5"
              :border-color="tab.active ? '#fff' : '#2c3e50'"
            />
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import debounce from 'lodash.debounce';
import NotificationSymbol from '@/components/NotificationSymbol.vue';
import statusTypes from '@/utils/statusTypes';
import svgs from '@/utils/icon-constants';

export default {
  name: 'TabHeader',
  components: {
    NotificationSymbol
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: null
    },
    tabs: {
      type: Array,
      default: () => []
    },
    allDisabled: {
      type: Boolean,
      default: false
    },
    applicationStatus: {
      type: String,
      default: ''
    },
    showHelpButton: {
      type: Boolean,
      default: false
    },
    isArchived: {
      type: Boolean,
      default: false
    },
    landlordName: {
      type: String,
      default: ''
    }
  },
  emits: ['helpButtonClicked', 'tabClick'],

  data() {
    return {
      useTransitionForActiveBg: false,
      bgTransitionTime: 300,
      svgs
    };
  },
  computed: {
    bgColorClass() {
      switch (this.applicationStatus) {
        case statusTypes.APPROVED:
          return 'green';
        case statusTypes.REJECTED:
          return 'red';
        case statusTypes.READY:
          return 'blue';
        case statusTypes.INCOMING:
          return 'purple';
        case statusTypes.ABORTED:
          return 'yellow';
        case statusTypes.CLOSED:
          return 'dark-green';
        case statusTypes.REMOVED:
        case statusTypes.PENDING_REMOVE:
          return 'grey';
        default:
          return '';
      }
    }
  },
  mounted() {
    this.setActiveBg(this.getCurrentTarget());
    // Wait for .active-bg transition to complete
    setTimeout(
      () => (this.useTransitionForActiveBg = true),
      this.bgTransitionTime
    );
    window.addEventListener('resize', debounce(this.refitActiveBg, 200));
  },
  destroy() {
    window.removeEventListener('resize', this.refitActiveBg);
  },
  updated() {
    this.setActiveBg(this.getCurrentTarget());
  },
  methods: {
    ...mapMutations({
      resetSecondPartOfTooltipsArray: 'app/resetSecondPartOfTooltipsArray'
    }),
    refitActiveBg() {
      this.setActiveBg(this.getCurrentTarget());
    },
    setActiveBg(target) {
      if (!target) {
        return;
      }
      const left = target.offsetLeft;
      const height = target.clientHeight;
      const width = target.clientWidth;
      this.$refs.activeBg.style.transform = `translateX(${left}px)`;
      this.$refs.activeBg.style.height = `${height}px`;
      this.$refs.activeBg.style.width = `${width}px`;
    },
    getCurrentTarget() {
      if (this.$refs && this.$refs.tabs && this.$refs.tabs.querySelector) {
        return this.$refs.tabs.querySelector('button.active');
      }
    },
    tabClick(tabLink, isActive) {
      if (isActive) {
        return;
      }
      this.$emit('tabClick', tabLink);
    },
    showTutorialOnClick() {
      this.resetSecondPartOfTooltipsArray();
      this.$emit('helpButtonClicked');
    }
  }
};
</script>

<style scoped>
.header {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: var(--color-dark-blue);
  position: relative;
  height: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.header.green {
  background-color: #339d64;
}
.header.red {
  background-color: rgb(var(--status-rejected));
}
.header.dark-green {
  background-color: rgb(var(--status-closed));
}
.header.grey {
  background-color: var(--color-grey);
}

.header.blue {
  background-color: var(--status-waiting);
}

.header.purple {
  background-color: var(--status-new);
}

.header.yellow {
  background-color: rgb(var(--status-aborted));
}

.subtitle.green {
  color: #339d64;
}
.subtitle.red {
  color: rgb(var(--status-rejected));
}
.subtitle.dark-green {
  color: rgb(var(--status-closed));
}
.subtitle.grey {
  color: var(--color-grey);
}

.subtitle.blue {
  color: var(--status-waiting);
}

.subtitle.purple {
  color: var(--status-new);
}

.subtitle.yellow {
  color: rgb(var(--status-aborted));
}

.title-help-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.title-help-container .title {
  position: relative;
  top: 25px;
  left: 35px;
  margin-bottom: -26px;
  color: #fff;
}

.title-help-container .title h2 {
  font-family: var(--font-poppins);
  font-size: 2.4rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 1rem;
}
.title-help-container .title small {
  font-size: 1.8rem;
}

.title-help-container .title .landlord-name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 800;
  font-size: 18px;
  line-height: 1;
}

.title-help-container .title .landlord-name img {
  width: 2rem;
  height: 2rem;
}

.title-help-container .link {
  position: relative;
  top: 25px;
  right: 35px;
  font-size: 2.4rem;
  margin-bottom: -26px;
  padding: 0;
  text-decoration: none;
  color: #fff;
  font-weight: 600;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: clamp(1.2rem, 0.8vw, 1.4rem);
  gap: 5px;
  transition: 0.3s;
}
.title-help-container .link:hover {
  transform: scale(1.1);
}

.title-inner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
}

.tabs {
  margin: 6rem 2.4rem 0;
}
.tabs-inner {
  position: relative;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
}
.tab {
  padding: 14px 25px 9px 30px;
  border-radius: 12px 12px 0 0;
  display: block;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  border: none;
  background: transparent;
  display: block;
  position: relative;
  z-index: 2;
  transition: 0.1s ease-in-out;
}

.tab :deep(svg) {
  width: 1.8rem;
  height: 1.8rem;
}

.tab.active {
  color: var(--color-dark-blue);
}

.tab.active :deep(svg path) {
  fill: var(--color-dark-blue);
}

.tab[disabled] {
  opacity: 0.4;
  cursor: default;
}
.active-bg {
  border-radius: 12px 12px 0 0;
  background: #fff;
  position: absolute;
  z-index: 1;
  bottom: -1px;
  left: 0;
  transition: 0.25s ease-in-out;
}
.active-bg--no-transition {
  transition: none;
}
/* ::v-deep .notification-container .notification-symbol {
  transition: 0.2s ease-in-out;
} */

.subtitle {
  background-color: #fff;
  border-radius: 10px;
  border: none;
  display: inline-block;
  font-weight: 600;
  font-size: 2rem;
  padding: 6px 15px;
  outline: none;
  text-align: center;
  text-transform: uppercase;
}

.subtitle:nth-last-child(2) {
  margin-right: 1rem;
}

.is-archived {
  display: block;
  width: 2.8rem;
  height: 2.8rem;
}

.is-archived svg {
  width: 100%;
  height: 100%;
}
</style>
